import React from "react";

const WEEK = [
  { v: "Mon", l: "M" },
  { v: "Tue", l: "T" },
  { v: "Wed", l: "W" },
  { v: "Thu", l: "T" },
  { v: "Fri", l: "F" },
  { v: "Sat", l: "S" },
  { v: "Sun", l: "S" },
];

export default function ServiceDaysStrip({ days = [], compact = false, label = "Weekly Service Days" }) {
  const set = new Set(days);
  return (
    <div data-testid="service-days-strip">
      {!compact && label && (
        <div className="text-[10px] uppercase tracking-[0.2em] text-[#5C738A] font-bold mb-1.5">{label}</div>
      )}
      <div className={`grid grid-cols-7 ${compact ? "gap-0.5" : "gap-1"}`}>
        {WEEK.map((d) => {
          const on = set.has(d.v);
          return (
            <div
              key={d.v}
              title={d.v}
              data-testid={`day-${d.v}-${on ? "on" : "off"}`}
              className={`text-center rounded-sm border font-bold tracking-wide transition-colors ${
                compact ? "py-0.5 text-[10px]" : "py-1.5 text-xs"
              } ${
                on
                  ? "bg-[#CFAB7A] text-[#012340] border-[#CFAB7A]"
                  : "bg-white text-[#012340]/30 border-[#012340]/10"
              }`}
            >
              {compact ? d.l : d.v}
            </div>
          );
        })}
      </div>
    </div>
  );
}
